import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent
  }
})
export default class AdminDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  hasCompany: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  user_id: any = [];
  role_id: any = [];
  company_id: any = [];
  genericErr: any = [];
  adminList: any = [];
  roleList: any = [];
  companyName: string = "";
  name: string = "";
  surname: string = "";
  birthdate: string = "";
  email: string = "";
  company: string = "";
  permissions: string = "";
  alias: string = "";
  createdAt: string = "";
  updatedAt: string = "";

  mounted (){
    const _ = this;
    _.getById();
    _.filterDate();
    _.getByCompany();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    console.log(date);
    date = date[0];
    return date;
  }

  getById(){
    const _ = this;
    _.user_id = location.href.split("/");
    _.user_id = _.user_id[5];
    _.isLoading = true;
    _.detailService.getById(_.user_id).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      console.log(data["data"], 'data')
      _.name = data["data"].user.name;
      _.surname = data["data"].user.surname;
      _.date = data["data"].user.date;
      _.email = data["data"].user.email;
      _.createdAt = data["data"].user.createdAt;
      _.updatedAt = data["data"].user.updatedAt;
      _.birthdate = data["data"].user.birthdate;
      _.alias = data["data"].user.role.alias;
      _.hasCompany = data["data"].user.company == null ? false : true;
      _.companyName = data["data"].user.company.name;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        // _.$router.push('/')
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getByCompany(){
    const _ = this;
    let company_id: any = location.href.split("/");
    company_id = company_id[5];
    _.isLoading = true;
    _.detailService.getByCompany(company_id).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.companyName = data["data"].company.name;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
